// extracted by mini-css-extract-plugin
export var backLink = "marathon-page-module--back-link--DjLQ8";
export var marathonWrapper = "marathon-page-module--marathon-wrapper--vVqWe";
export var page = "marathon-page-module--page--RqBmz";
export var title = "marathon-page-module--title--GrD0P";